<template>
    <v-container>
        <v-form ref="form" v-model="valid" lazy-validation>
            <v-btn color="primary" @click="newAnexo" dark>Nuevo Archivo</v-btn>

            <v-dialog
                    v-model="dialog"
                    width="500px" hide-overlay
                    transition="dialog-bottom-transition"
                    scrollable>
                <v-card tile>
                    <v-toolbar card dark color="nav_background_color">
                        <v-btn icon dark @click.native="dialog = false" @click="cleanData">
                            <v-icon>close</v-icon>
                        </v-btn>
                        <v-toolbar-title>Nuevo Archivo</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <v-form ref="form" v-model="valid" lazy-validation>

                            <v-layout>
                                <v-flex xs12 sm10 offset-sm1>
                                    <div id="app">
                                        <input id="files" type="file" @change="handleFileSelect">
                                        <input id="nameFile"/>
                                    </div>
                                </v-flex>
                            </v-layout>
                          <v-layout>
                            <v-flex xs12 sm10 offset-sm1>
                              <v-text-field
                                  v-model="anexo.description"
                                  label="Descripción"
                                  :rules="[v => !!v || 'Es requerido', v => (v && v.length <= 500) || 'El número de caracteres debe ser menor a 500']"
                                  required
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                            <div class="text-xs-center">
                                <v-btn color="primary" @click="saveFile" dark>Guardar</v-btn>
                            </div>
                        </v-form>
                    </v-card-text>
                    <div style="flex: 1 1 auto;"></div>
                </v-card>
            </v-dialog>
        </v-form>

        <div>
            <v-layout>
                <v-flex xs12 sm6 offset-sm6>
                    <v-text-field
                            v-model="search"
                            append-icon="search"
                            label="Buscar"
                            single-line
                            hide-details
                    ></v-text-field>
                </v-flex>
            </v-layout>
        </div>
        <br>
        <br>
        <v-data-table
                :headers="headers"
                :items="$store.state.activityFileList"
                class="elevation-1"
                sort-icon="mdi-menu-down"
                :search="search"
        >
            <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.fileName }}</td>
                <td class="text-xs-left">{{ props.item.description }}</td>
              <td class="text-xs-left"><a @click="download(props.item)">Descargar</a></td>
                <td>
                    <v-tooltip top>
                        <v-btn fab dark small @click="deleteItem(props.item)" slot="activator" color="primary">
                            <v-icon dark>delete</v-icon>
                        </v-btn>
                        <span>Eliminar</span>
                    </v-tooltip>
                </td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                No se han encontrado resultados para "{{ search }}".
            </v-alert>
        </v-data-table>
    </v-container>
</template>
<script>

    import AnexoActivity from "../../model/AnexoActivity";

    export default {
        props: ['company'],
        data() {
            return {
                radioGroup: 1,
                search: '',
                valid: false,
                requiredField: [v => !!v || 'Es requerido'],
                dialog: false,
                dialogDiagnostic: false,
                diagnostico: {nombre: "", clase: "", tipo: ""},
                dialogSuccess: false,
                editedIndex: -1,
                show: false,
                anexo: new AnexoActivity(),
                headers: [
                    {text: 'Nombre', value: 'fileName'},
                    {text: 'Descripcion', value: 'description'},
                    {text: 'Descargar', value: 'descargar'},
                    {text: 'Eliminar', value: 'eliminar'}
                ],
                list: [],
                years: [],
                uploadOptions: {
                    headers: {
                        Authorization: 'Client-ID YOURIMGURIDHERE'
                    }
                },
                clases: ["PRE", "DEF"],
                tipos: ["PRI", "SUB", "REF"]
            };
        },
        methods: {
            cleanData() {
                this.anexo = new AnexoActivity()
                this.dialogDiagnostic = false
            },
            newAnexo() {
                this.anexo = new AnexoActivity()
                this.editedIndex = -1
                this.dialog = true
            },
            getDateNow() {
                var today = new Date();
                var dd = today.getDate();
                var mm = today.getMonth() + 1; //January is 0!

                var yyyy = today.getFullYear()
                today.getHours()
                if (dd < 10) {
                    dd = '0' + dd;
                }
                if (mm < 10) {
                    mm = '0' + mm;
                }
                var today = dd + '/' + mm + '/' + yyyy + " " + today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
                return today
            },
            getYears() {
                let currentYear = new Date().getFullYear()
                for (let i = currentYear; i >= 1945; i--) {
                    this.years.push(i)
                }
            },

            saveFile() {
                if (this.$refs.form.validate()) {
                    // this.anexo.file = document.getElementById('base64').value
                    if (this.editedIndex == -1) {
                      this.anexo.activity= {id:this.$store.state.activity.id}
                        this.anexo.date = new Date()
                        this.$store.dispatch('addActivityFile', this.anexo).then(response => {
                            this.dialog = false
                            document.getElementById("files").value = "";
                            this.anexo = new AnexoActivity()
                            this.reloadData()
                        }, error => {
                            this.$store.state.progress = false
                            this.$store.state.dialogError = true
                        })
                    } else {
                        this.$store.dispatch('updateActivityFile', this.anexo).then(response => {
                            this.dialog = false
                            document.getElementById("files").value = "";
                            this.anexo = new AnexoActivity()
                            this.cleanData()
                        }, error => {
                            this.$store.state.progress = false
                            this.$store.state.dialogError = true
                        })
                    }
                } else {
                    this.dialogError = true
                }
            },


            deleteItem(item) {
                this.editedIndex = this.$store.state.activityFileList.indexOf(item)
                this.anexo = Object.assign({}, item)
                confirm('Está seguro de que quiere eliminar el registro?') && this.$store.dispatch('deleteActivityFile', this.anexo.id).then(response => {
                 this.reloadData()
                }, error => {
                  this.$store.state.progress = false;
                  this.$store.state.dialogError = true;
                });
            },
            formatDate(date) {
                var hours = date.getHours();
                var minutes = date.getMinutes();
                var seconds = date.getSeconds();
                var ampm = hours >= 12 ? 'pm' : 'am';
                hours = hours % 12;
                hours = hours ? hours : 12; // the hour '0' should be '12'
                minutes = minutes < 10 ? '0' + minutes : minutes;
                var strTime = hours + ':' + minutes + ":" + seconds + ' ' + ampm;
                return date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear() + "  " + strTime;
            },
            handleFileSelect(evt) {
                this.$store.state.fileData.push(evt.target.files[0])
                this.anexo.fileName = evt.target.files[0].name
                this.anexo.fileType = evt.target.files[0].type
                this.anexo.file = window.btoa("binaryData");
                let f = evt.target.files[0]; // FileList object
                let reader = new FileReader();
                const self = this;
                // Closure to capture the file information.
                reader.onload = (function (f) {
                    return function (e) {
                        let binaryData = e.target.result;
                        //Converting Binary Data to base 64
                        let base64String = window.btoa(binaryData);
                        self.anexo.file = base64String
                    };
                })(f);
                // Read in the image file as a data URL.
                reader.readAsBinaryString(f);
            },

            download(item) {
              console.log(this.editedIndex)
                this.editedIndex = this.$store.state.activityFileList.indexOf(item)
              console.log("this.editedIndex")

              console.log(this.$store.state.activityFileList[this.editedIndex])
                this.$store.dispatch('getActivityFile', this.$store.state.activityFileList[this.editedIndex].id).then(response => {
                    const byteCharacters = atob(response.data.file);
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    const blob = new Blob([byteArray], {type: response.data.fileType});
                    let objectURL = window.URL.createObjectURL(blob);

                    if (navigator.appVersion.toString().indexOf('.NET') > 0) {
                        window.navigator.msSaveOrOpenBlob(blob, response.data.fileName);
                    } else {
                        let link = document.createElement('a');
                        link.href = objectURL;
                        link.download = response.data.fileName;
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                    }
                }, error => {

                })

            },

            reloadData() {
                //this.$store.state.fileData=[]
                this.$store.dispatch('getActivityFileByActivity', this.$store.state.activity.id).then(response => {

                }, error => {
                    this.$store.state.progress = false;
                    this.$store.state.dialogError = true;
                })
            },


        },
        computed: {},
        created() {
            this.reloadData()
        },

    };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/activity/ActivityFile.vue